import { useRef } from 'react'
import { SDrawerOrModal, SGeneralForms } from 'shj-components'
import { Button, message, Select, Spin } from 'antd'
import { useSetState } from 'ahooks'
import { getJdPin, bindJdOrder } from '@/services/order'
import { getJdOrderList } from '@/services/jd'
import { getDictServer } from '@/services/channelManagement'
import { cancelPaymentApply } from '@/services/fmsServices'
interface IProps {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  record?: any
  reload: () => void
}
export default function LinkJd(prpos: IProps) {
  const formRef = useRef(null)
  const { open, title, setOpen, record, reload } = prpos
  const [state, setState] = useSetState<any>({
    btnLoading: false,
    reaseonList: [],
  })

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const onsubmit = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        setState({ btnLoading: true })
        cancelPaymentApply({
          id: record?.id,
          cancelCode: values.cancelCode,
        })
          .then(res => {
            message.success('提交成功')
            reload?.()
            onCancel()
          })
          .finally(() => {
            setState({ btnLoading: false })
          })
      })
  }
  const onCancel = () => {
    onFormRef()?.resetFields()
    setOpen(false)
  }

  const getOptions = async () => {
    const list = await getDictServer({ key: 'jdCancelReason' })
    setState({ reaseonList: list })
    return Promise.resolve({ reaseonList: list })
  }
  return (
    <SDrawerOrModal
      title={title}
      mode="modal"
      open={open}
      width={500}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div>
            <Button onClick={onCancel}>取消</Button>
            <Button
              style={{ marginLeft: 15 }}
              loading={state.btnLoading}
              type="primary"
              onClick={onsubmit}
            >
              提交
            </Button>
          </div>
        ),
        maskClosable: false,
      }}
    >
      {open && (
        <div>
          <SGeneralForms
            ref={formRef}
            httpOptionsFn={getOptions}
            layout={'vertical'}
            configs={[
              {
                formItem: [
                  {
                    spanCol: 24,
                    label: '',
                    name: 'cancelCode',
                    rules: [{ required: true, message: '请选择取消原因' }],
                    children: (
                      <Select
                        placeholder={'请选择取消原因'}
                        showSearch
                        optionFilterProp="name"
                        fieldNames={{ label: 'name', value: 'priKey' }}
                        allowClear
                        options={state.reaseonList}
                      />
                    ),
                  },
                ],
              },
            ]}
          />
        </div>
      )}
    </SDrawerOrModal>
  )
}
